// extracted by mini-css-extract-plugin
export default {"IncludeTargetIcon":"IncludeExcludeTarget-module__IncludeTargetIcon__AS7CSpR","ExcludeTargetIcon":"IncludeExcludeTarget-module__ExcludeTargetIcon__DUMU5Gg"};